/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
    setSidebarCollapsed(state, collapsed) {
        state.isSidebarCollapsed = !!collapsed
        try {
            localStorage.setItem('ui.sidebarCollapsed', collapsed ? '1' : '0')
        } catch (e) {
            /* ignore */
        }
    },
    setMobileMenuOpen(state, open) {
        state.isMobileMenuOpen = !!open
    }
}
